import { FC } from 'react';
import PaywallSignup from './PaywallSignup';
import PaywallTrialOver from './PaywallTrialOver';
import PaywallValidateEmail from './PaywallValidateEmail';
import useUser from '@utils/context/user';

const Paywall: FC = () => {
    const { info: user, privileges } = useUser();

    if (!user) {
        return <PaywallSignup />;
    }
    if (!privileges?.isEmailVerified) {
        return <PaywallValidateEmail />;
    }
    if (!privileges?.isAllowedToConsumePaidContent) {
        return <PaywallTrialOver />;
    }

    return null;
};

export default Paywall;
